import { useState } from 'react';
import WaitlistSignUpModal from '../modals/WaitlistSignUpModal';

interface WaitlistSignUpButtonProps {
  className?: string;
  variant?: 'primary' | 'white';
}

export default function WaitlistSignUpButton({ className = '', variant = 'primary' }: WaitlistSignUpButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const buttonStyles = variant === 'white'
    ? 'bg-white text-primary hover:bg-blue-50'
    : 'bg-primary text-white hover:bg-blue-700';

  return (
    <>
      <button
        onClick={() => setIsModalOpen(true)}
        className={`${buttonStyles} px-8 py-3 rounded-full font-semibold transition-colors ${className}`}
      >
        Join Waitlist
      </button>

      <WaitlistSignUpModal 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
} 